export default {
    OpenApi: {
        menu: 'Open API',
        appList: 'แอป API',
        createApp: 'สร้างแอป',
        cancel: 'ยกเลิก',
        source: 'แหล่งที่มา',
        sourcePage: 'หน้าเว็บ',
        sourceApi: 'API',
        requestNo: 'เลขคำขอลูกค้า',
        batchNo: 'ชุด',
        actualAmount: 'จำนวนที่ดำเนินการจริง',
        walletAmount: 'หัก/เข้ากระเป๋าเงิน',
        bindRecords: 'บันทึกผูก/ยกเลิกผูก API',
        dataTime: 'เวลาข้อมูล',
        action: 'การดำเนินการ',
        bind: 'ผูก',
        unbind: 'ยกเลิกผูก',
        targetBc: 'BC เป้าหมาย',
        result: 'ผลลัพธ์',
        reason: 'เหตุผล',
        verifiedAt: 'เวลายืนยัน',
        appSecret: 'App Secret',
        resetSecret: 'รีเซ็ตคีย์',
        resetConfirm: 'คีย์เดิมจะใช้ไม่ได้ทันทีหลังรีเซ็ต ดำเนินการต่อหรือไม่?',
        secretTitle: 'กรุณาบันทึก App Secret',
        secretTip: 'คีย์จะแสดงเพียงครั้งเดียวและดูซ้ำไม่ได้ ระบบเก็บเฉพาะค่าแฮช กรุณาคัดลอกและเก็บรักษาทันที หากสูญหายต้องรีเซ็ต',
        copy: 'คัดลอก',
        copied: 'คัดลอกแล้ว',
        savedIt: 'ฉันบันทึกแล้ว',
        appName: 'ชื่อแอป',
        appId: 'App ID',
        keyId: 'Key ID',
        publicKey: 'กุญแจสาธารณะ',
        publicKeyTip: 'สร้างคู่กุญแจ RSA ในเครื่อง (2048-4096 บิต, PS256) และวางเฉพาะกุญแจสาธารณะ (PEM หรือ JWK) ห้ามอัปโหลดกุญแจส่วนตัว',
        ipList: 'รายการ IP ที่อนุญาต',
        ipListTip: 'หนึ่งบรรทัดต่อหนึ่ง IP สาธารณะหรือ CIDR IPv4 ขั้นต่ำ /8, IPv6 ขั้นต่ำ /32 สูงสุด 50 รายการ',
        status: 'สถานะ',
        statusPending: 'รอเปิดใช้งาน',
        statusActive: 'เปิดใช้งานแล้ว',
        statusRevoked: 'เพิกถอนแล้ว',
        scopes: 'สิทธิ์ที่เปิดใช้',
        accounts: 'จำนวนบัญชีที่ได้รับอนุญาต',
        readonlyTip: 'สิทธิ์และบัญชีที่ได้รับอนุญาตจะเปิดให้หลังตรวจสอบ และดูได้อย่างเดียว',
        createdAt: 'เวลาที่สร้าง',
        detail: 'รายละเอียด',
        addKey: 'เพิ่มกุญแจสาธารณะ (เปลี่ยนกุญแจ)',
        revokeKey: 'เพิกถอนกุญแจนี้',
        updateIp: 'แก้ไขรายการ IP',
        revokeApp: 'เพิกถอนแอป',
        revokeConfirm: 'แอปจะใช้งานไม่ได้ทันทีหลังเพิกถอน ดำเนินการต่อหรือไม่?',
        smsTitle: 'การยืนยันความปลอดภัย',
        smsTip: 'การดำเนินการนี้กระทบข้อมูลรับรองของ API การเงิน กรุณายืนยันด้วย SMS ก่อน',
        sendCode: 'รับรหัส',
        code: 'รหัสยืนยัน',
        verifyAndSubmit: 'ยืนยันและส่ง',
        codeRequired: 'กรุณากรอกรหัสยืนยัน',
        nameRequired: 'กรุณากรอกชื่อแอป',
        keyRequired: 'กรุณาวางกุญแจสาธารณะ',
        ipRequired: 'กรุณากรอก IP อย่างน้อยหนึ่งรายการ',
        success: 'สำเร็จ',
        empty: 'ยังไม่มีแอป',
        enterpriseOnly: 'เฉพาะบัญชีหลักขององค์กรเท่านั้นที่จัดการแอป API ได้',
    },
    menu: { // 登录
        home: 'หน้าแรก',
        foundApply: 'ใบสมัครเปิดบัญชี',
        foundTikTokBatch: 'เปิดบัญชี TikTok เป็นชุด',
        account: 'การจัดการบัญชี',
        subAccount: 'การจัดการบัญชีรอง',
        accountList: 'รายการบัญชี',
        subAccountList: 'รายการบัญชีรอง',
        accountRecord: 'บันทึกการเปิดบัญชี',
        accountRecharge: 'การชาร์จอัจฉริยะ',
        accountMonitor: 'การตรวจสอบบัญชี',
        accountMonitorEr: 'การตรวจสอบบัญชี',
        check: 'การจัดการการกระทบยอดบัญชี',
        checkWallet: 'บันทึกการเติมเงินวอลเล็ท',
        checkBalance: 'รายละเอียดกระเป๋าสตางค์',
        checkCreditBalance: 'รายละเอียดยอดเครดิตคงเหลือ',
        CheckConsume: 'รายละเอียดการบริโภคโฆษณา',
        helpCenter: 'ศูนย์ช่วยเหลือ',
        marketingTool: 'เครื่องมือการตลาดแบบผู้มีอิทธิพล',
        crossBorderBrowser: 'เบราว์เซอร์ข้ามพรมแดน',
        storeOperationTools: 'เครื่องมือดำเนินการร้านค้า TK',
        AdvertisementManagement: 'การจัดการโฆษณา',
        TikTok: 'TikTok',
        Partner: 'พันธมิตร',
        USCloudPhone: 'หมายเลขโทรศัพท์คลาวด์ของสหรัฐอเมริกา',
        AccountOpeningManagement: 'การจัดการการเปิดบัญชี',
        cooperativePartner: 'พันธมิตร',
        subClient: 'การจัดการลูกค้าย่อย',
        subClientList: 'รายชื่อลูกค้าย่อย',
        subClientAdvertiserList: 'รายชื่อโฆษณาของลูกค้าย่อย',
        subClientCheckWallet: 'บันทึกธุรกรรม',
        subClientAccountRecord: 'บันทึกการเปิดบัญชีลูกค้าย่อย',
        promotion: 'โปรโมชั่น',
        agentSubAccount: 'รายชื่อบัญชีย่อยรุ่นที่สอง',
        mediaAuth: 'การจัดการสื่อ',
        advertiserTransaction: 'รายละเอียดธุรกรรมโฆษณา',
        advertiserTransfer: 'รายละเอียดการโอนโฆษณา',
        checkCreditLimit: 'บันทึกการเปลี่ยนแปลงเครดิต',


    }, crumb: {
        home: 'หน้าแรก',
        foundApply: 'ใบสมัครเปิดบัญชี',
        foundTikTokBatch: 'เปิดบัญชี TikTok เป็นชุด',
        Account: 'การจัดการบัญชี',
        AccountList: 'รายการบัญชี',
        AccountRecord: 'บันทึกการเปิดบัญชี',
        AccountRecharge: 'การชาร์จอัจฉริยะ',
        AccountMonitor: 'การตรวจสอบบัญชี',
        Check: 'การจัดการการกระทบยอดบัญชี',
        CheckWallet: 'บันทึกการเติมเงินวอลเล็ท',
        CheckBalance: 'รายละเอียดกระเป๋าสตางค์',
        CheckCredit: 'รายละเอียดยอดเครดิตคงเหลือ',
        CheckConsume: 'รายละเอียดการบริโภคโฆษณา',
        CheckLimit: 'รายละเอียดธุรกรรมเครดิต'
    }, header: {
        Settings: 'การตั้งค่าบัญชี',
        LogOut: 'ล้มเลิก'
    }, home: { // 登录
        AssetOverview: 'ภาพรวมสินทรัพย์',
        wallet: 'ยอดเงินในกระเป๋าสตางค์',
        AdvertisingAccount: 'ยอดเงินในบัญชีโฆษณา',
        PlatformWallet: 'กระเป๋าสตางค์แบบแพลตฟอร์ม',
        creditBalance: 'ยอดเงินคงเหลือ',
        RechargeWallet: 'เติมเงินวอลเล็ท',
        ViewDetails: 'ดูรายละเอียด',
        ActiveAccountBalance: 'ยอดเงินคงเหลือในบัญชีใช้งานอยู่',
        FrozenBalance: 'หยุดสมดุล',
        PlatformGifts: 'โบนัสแพลตฟอร์ม',
        UsedCredit: 'เครดิตที่ใช้',
        CreditLimit: 'วงเงินสินเชื่อ',
        AccountOpeningApplication: 'ใบสมัครเปิดบัญชี',
        inReview: 'อยู่ระหว่างการพิจารณา',
        ToBeModified: 'จะถูกปรับเปลี่ยน',
        GoAndModifyIt: 'ปรับปรุงใหม่',
        DisableRate: 'อัตราการปิดการบริโภค',
        AccountDisableRate: 'อัตราการปิดบัญชี',
        PassedInThePast30Days: 'ผ่านไปแล้ว 30 วัน',
        ApplyForAccountOpening: 'สมัครเปิดบัญชี',
        PopularEntrance: 'ทางเข้ายอดนิยม',
        AccountOpeningApplication2: 'ใบสมัครเปิดบัญชี',
        IntelligentRecharge: 'การชาร์จอัจฉริยะ',
        AccountReconciliationManagement: 'การจัดการการกระทบยอดบัญชี',
        account: 'การจัดการบัญชี',
        WalletRecharge: 'เติมเงินวอลเล็ท',
        RechargeAmount: 'จำนวนเงินที่เติม',
        EnterAmount: 'กรุณากรอกจำนวนเงินที่เติม',
        PaymentMethod: 'วิธีการชำระเงิน',
        Cancel: 'ยกเลิก',
        ConfirmRecharge: 'ยืนยันการเติมเงิน',
        Message1: "ยอดเงิน USD ที่คุณเติมเข้าบัญชีแพลตฟอร์มของคุณ，",
        Message2: "ไม่รวมยอดเงินที่ถูกชาร์จเข้าแพลตฟอร์มสื่อ",
        Message3: "ยอดคงเหลือรวมของบัญชีโฆษณาแพลตฟอร์มสื่อ",
        Message4: "ยอดเงินคงเหลือของเครดิตที่ได้รับจากแพลตฟอร์ม，",
        Message5: "วิธีการคำนวณ คือ วงเงินสินเชื่อรวม – วงเงินสินเชื่อที่ใช้ไป",
        Message6: "มีคุณสมบัติใหม่ ๆ พร้อมให้บริการแล้ว! ตรวจสอบวิธีการใช้งานได้ในศูนย์ช่วยเหลือ",
        Validity: 'ความถูกต้อง',
    }, login: { // 登录
        title: 'เข้าสู่ระบบ',
        NoAccount: 'ไม่มีบัญชี？',
        register: 'ไปที่ลงทะเบียน',
        WelcomeToLogin: 'ยินดีต้อนรับเข้าสู่การเข้าสู่ระบบ',
        PleaseEnterYourPhoneNumberOrEmailAddress: 'กรุณากรอกเบอร์โทรศัพท์หรืออีเมล์ของคุณ',
        PleaseEnterYourLoginPassword: 'กรุณากรอกรหัสผ่านเข้าระบบ',
        ForgotPassword: 'ลืมรหัสผ่าน？',
        VerificationCodeLogin: 'รหัสยืนยันการเข้าสู่ระบบ',
        logOn: 'เข้าสู่ระบบ',
        LoginSuccess: 'เข้าสู่ระบบสำเร็จแล้ว กำลังเปลี่ยนเส้นทาง。。。',
        Mail: 'อีเมล',
        Password: 'รหัสผ่าน',
        VerificationCode: 'รหัสยืนยัน',
        MasterAccountLogin: 'เข้าสู่ระบบบัญชีหลัก',
        SubAccountLogin: 'เข้าสู่ระบบบัญชีย่อย'
    }, register: { // 注册
        title: 'ลงทะเบียน',
        ExistingAccount: 'มีบัญชีอยู่แล้ว？',
        GoLogIn: 'ไปที่การเข้าสู่ระบบ',
        WelcomeToRegister: 'ยินดีต้อนรับเข้าสู่การลงทะเบียน',
        PleaseEnterYourPhoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ (เพื่อใช้เป็นบัญชีหลักในการเข้าสู่ระบบ)',
        LoginPassword: 'หมายเหตุ : รหัสผ่านต้องประกอบไปด้วยตัวอักษรพิมพ์ใหญ่และพิมพ์เล็ก และตัวเลข (ไม่จำกัดจำนวนอักขระ)',
        InvitationCode: 'รหัสคำเชิญ',
        PlaInvitationCode: 'หมายเหตุ: กรุณากรอกรหัสเชิญหากคุณมี มิฉะนั้นคุณไม่จำเป็นต้องกรอก',
        ObtainVerificationCode: 'รับรหัสยืนยัน',
        PleaseEnterYourFrequentlyUsedEmail: 'กรุณากรอกอีเมลปกติของคุณ (เนื่องจากเป็นบัญชีสำรอง รายการนี้ไม่จำเป็น)',
        PleaseEnterA6_20DigitLoginPassword: 'กรุณาใส่รหัสผ่านในการเข้าสู่ระบบที่มีความยาว 6-20 ตัวอักษร (ต้องประกอบไปด้วยตัวอักษรพิมพ์ใหญ่และพิมพ์เล็กและตัวเลข)',
        FreeRegistration: 'ลงทะเบียนฟรี',
        IHaveReadAndAmWillingToAccept: 'ฉันได้อ่านและยอมรับ',
        TermsOfService: 'เงื่อนไขการบริการ',
        and: 'และ',
        PrivacyStatement: 'คำชี้แจงความเป็นส่วนตัว',
        ElMPleaseEnterYourPhoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ',
        ElMPleaseEnterYourEmailNumber: 'กรุณากรอกที่อยู่อีเมล์ของคุณ',
        ElMPleaseEnterTheVerificationCode: 'กรุณากรอกรหัสยืนยัน',
        ElMPleaseEnterPassword: 'กรุณากรอกรหัสผ่านของคุณ',
        PleaseAgreeToTheServiceAgreement: 'กรุณายอมรับข้อตกลงการให้บริการ',
        SuccessfullySentSMSVerificationCode: 'ส่งรหัสยืนยันทาง SMS เรียบร้อยแล้ว',
        SuccessfullySentEmailVerificationCode: 'ส่งรหัสยืนยันทางอีเมล์เรียบร้อยแล้ว',
        UserAgreement: 'ข้อตกลงผู้ใช้',
        UserAgreementAdvertisingComplianceManagementSystem: 'ระบบการจัดการการปฏิบัติตามกฎเกณฑ์การโฆษณา',
        ServiceAndInformationCollectionAgreement: 'ข้อตกลงการให้บริการและการรวบรวมข้อมูล',
        AccountLogin: 'เข้าสู่ระบบบัญชี',
        EmailLogin: 'เข้าสู่ระบบอีเมล'
    }, forget: {// 找回密码
        title: 'กู้คืนรหัสผ่านของคุณ',
        NoAccount: 'ไม่มีบัญชี？',
        register: 'ไปที่ลงทะเบียน',
        RetrievePassword: 'กู้คืนรหัสผ่านของคุณ',
        PleaseEnterYourPhoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ',
        PleaseEnterTheMobileVerificationCode: 'กรุณากรอกรหัสยืนยันมือถือ',
        SuccessfullySentSMSVerificationCode: 'ส่งรหัสยืนยันทาง SMS เรียบร้อยแล้ว',
        ObtainVerificationCode: 'รับรหัสยืนยัน',
        ReturnToLogin: 'กลับไปยังหน้าเข้าสู่ระบบ',
        VerifyWithEmail: 'ยืนยันทางอีเมล์',
        PleaseEnterYourEmailNumber: 'กรุณากรอกที่อยู่อีเมล์ของคุณ',
        PleaseEnterTheEmailVerificationCode: 'กรุณากรอกรหัสยืนยันอีเมล์',
        SuccessfullySentEmailVerificationCode: 'ส่งรหัสยืนยันทางอีเมล์เรียบร้อยแล้ว',
        VerifyWithMobilePhone: 'ยืนยันด้วยโทรศัพท์มือถือ',
        Verify: 'ตรวจสอบ',
        NewPassword: 'กรุณากรอกรหัสผ่านใหม่',
        AgainNewPassword: 'กรุณากรอกรหัสผ่านใหม่อีกครั้ง',
        NewPasswordLogin: 'การแก้ไขสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง',
    }, loginSMS: {// 验证码登录
        title: 'รหัสยืนยันการเข้าสู่ระบบ',
        NoAccount: 'ไม่มีบัญชี？',
        register: 'ไปที่ลงทะเบียน',
        WelcomeToLogin: 'ยินดีต้อนรับเข้าสู่การเข้าสู่ระบบ',
        PleaseEnterYourPhoneNumber: 'กรุณากรอกเบอร์โทรศัพท์ของท่าน',
        PleaseEnterTheMobileVerificationCode: 'กรุณากรอกรหัสยืนยันมือถือ',
        SuccessfullySentSMSVerificationCode: 'ส่งรหัสยืนยันทาง SMS เรียบร้อยแล้ว',
        ObtainVerificationCode: 'รับรหัสยืนยัน',
        PleaseEnterYourEmailAddress: 'กรุณากรอกที่อยู่อีเมล์ของคุณ',
        PleaseEnterTheEmailVerificationCode: 'กรุณากรอกรหัสยืนยันอีเมล์',
        SuccessfullySentEmailVerificationCode: 'ส่งรหัสยืนยันทางอีเมล์เรียบร้อยแล้ว',
        PasswordLogin: 'รหัสผ่านเข้าระบบ',
        EmailVerificationCodeLogin: 'เข้าสู่ระบบรหัสยืนยันอีเมล',
        MobileVerificationLogin: 'การเข้าสู่ระบบยืนยันโทรศัพท์มือถือ',
        logOn: 'เข้าสู่ระบบ'
    }, password: { // 修改密码
        title: 'เข้าสู่ระบบ',
        ChangePassword: 'เปลี่ยนรหัสผ่าน',
        PleaseEnterANewPassword: 'กรุณาระบุรหัสผ่านใหม่ 6 ถึง 20 ตัวอักษร (รวมทั้งตัวอักษรพิมพ์ใหญ่และพิมพ์เล็กและตัวเลข)',
        PleaseEnterANewPassword2: 'กรุณากรอกรหัสผ่านใหม่',
        PleaseEnterTheNewPasswordAgain: 'กรุณากรอกรหัสผ่านใหม่อีกครั้ง',
        ConfirmModifications: 'ยืนยันการเปลี่ยนแปลง',
        ReturnToLogin: 'กลับไปยังหน้าเข้าสู่ระบบ',
        ModificationSuccessful: 'การแก้ไขสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง'
    }, foundApply: { // 开户申请
        OfficialAuthorizedServiceProvider: 'ผู้ให้บริการที่ได้รับอนุญาต',
        TikTok: 'แพลตฟอร์มโซเชียลวิดีโอสั้นที่ได้รับความนิยมทั่วโลก มีผู้ใช้วัยรุ่นจำนวนมาก และมีอัตราการแปลงสูงผ่านเนื้อหาวิดีโอสั้นที่มีการเบี่ยงเบนและการเปิดเผยปริมาณการใช้งานที่แข็งแกร่ง。',
        Google: 'บริษัทเครื่องมือค้นหาที่ใหญ่ที่สุดในโลก มีผู้ใช้งานรายเดือนเกือบ 3 พันล้านคน แสดงโฆษณาในช่วงเวลาที่ลูกค้าค้นหาผลิตภัณฑ์หรือบริการของคุณพอดี。',
        Facebook: 'จ่ายตามคลิกหรือต่อการเข้าชมหนึ่งพันครั้ง ทำงานได้เร็วมาก และใช้งานง่ายมาก นอกจากนี้ นักโฆษณายังสามารถใช้รายงานเพื่อเข้าใจสถานะการทำงานของโฆษณาต่างๆ ได้รวดเร็วยิ่งขึ้น。',
        ApplyNow: 'สมัครเลยตอนนี้',
        BatchApply: 'เปิดบัญชีเป็นชุด',
        ComingSoon: 'เร็วๆ นี้',
        Kwai: 'Kwai เรามุ่งมั่นที่จะสนับสนุนผู้ใช้ในการแบ่งปันประสบการณ์ชีวิตและสร้างคุณค่าให้กับผู้ใช้และธุรกิจ เราเชื่อว่าการสื่อสารและการมีปฏิสัมพันธ์ระหว่างผู้คนสามารถนำมาซึ่งโอกาสทางธุรกิจได้ การสร้างความสัมพันธ์กับผู้ใช้จะช่วยสร้างประโยชน์ให้กับแบรนด์ของคุณ',
        TemporarilyClose: 'ปิดให้บริการชั่วคราว',
    }, foundTikTok: { // 开户申请TikTok
        Tip: "ข้อกำหนดใบอนุญาตประกอบธุรกิจ:",
        Tip1: "1.โปรดจัดเตรียมใบอนุญาตประกอบธุรกิจของจีนแผ่นดินใหญ่หรือฮ่องกงที่ชัดเจนและไม่มีลายน้ำ และต้องเป็นเวอร์ชันล่าสุด",
        Tip2: "2.ตรวจสอบให้แน่ใจว่ารหัส QR ด้านล่างใบอนุญาตประกอบธุรกิจสามารถระบุได้",
        Tip3: "3.หากรูปถ่ายใบอนุญาตประกอบธุรกิจหรือใบรับรองรหัสองค์กรที่ส่งมาไม่ชัดเจนหรือไม่สมบูรณ์ จะทำให้เกิดความไม่ตรงกัน กรุณาตรวจสอบก่อนยื่นใบสมัครเปิดบัญชี",
        Tip1Sea: "1.โปรดจัดเตรียมใบอนุญาตประกอบธุรกิจในเอเชียตะวันออกเฉียงใต้ที่ชัดเจนและไม่มีลายน้ำ และต้องเป็นเวอร์ชันล่าสุด",
        Port: "เลือกพอร์ต",
        PortTip: "กรุณาเลือกพอร์ต",
        PortCnob: "CNOB ในประเทศ",
        PortChinaEntity: "นิติบุคคลจีน",
        PortSea: "เอเชียตะวันออกเฉียงใต้",
        PortAreaMismatch: "ประเทศที่จดทะเบียนไม่ตรงกับพอร์ตที่เลือก นิติบุคคลจีนใช้จีนแผ่นดินใหญ่หรือฮ่องกง เอเชียตะวันออกเฉียงใต้ใช้ประเทศตามใบอนุญาต",
        QualificationType: "ประเภทคุณสมบัติ",
        BusinessLicense: 'ใบอนุญาตประกอบธุรกิจ เวอร์ชั่นไม่มีลายน้ำ',
        BusinessLicenseTip: 'กรุณาอัพโหลดเอกสารแนบใบอนุญาตประกอบธุรกิจ',
        LicenseTip: 'ใบอนุญาตประกอบธุรกิจคือเอกสารที่พิสูจน์ความถูกต้องตามกฎหมายของบริษัทคุณ กรุณาอัพโหลดไฟล์ PNG, JPG, JPEG',
        CompanyRegistrationLocation: 'สถานที่จดทะเบียนบริษัท',
        CompanyRegistrationLocationTip: 'กรุณาเลือกสถานที่จดทะเบียนบริษัท',
        CompanyName: 'ชื่อบริษัท',
        CompanyNameTip: 'กรุณากรอกชื่อบริษัทของคุณ',
        BusinessLicenseNumber: 'รหัสเครดิตทางสังคม',
        BusinessLicenseNumberTip: 'กรุณากรอกรหัสเครดิตสังคมของคุณ',
        AccountTimeZone: 'เขตเวลาของบัญชี',
        AccountTimeZoneTip: 'กรุณาเลือกโซนเวลาบัญชีของคุณ',
        PromotionLink: 'ลิงค์พันธมิตร',
        PromotionLinkTip: 'กรุณากรอกลิงค์โปรโมชั่น',
        PromotionLinkTip2: 'กรุณากรอกรูปแบบลิงค์ที่ถูกต้อง',
        ContactEmail: 'ติดต่ออีเมล์',
        ContactEmailTip: 'กรุณากรอกอีเมล์ติดต่อ',
        ContactEmailTip2: 'กรุณากรอกรูปแบบอีเมล์ให้ถูกต้อง',
        BusinessCenterID: 'รหัสศูนย์ธุรกิจ',
        BusinessCenterIDTip: 'กรุณากรอกรหัสศูนย์ธุรกิจของคุณ',
        Reset: 'รีเซ็ต',
        Submit: 'ส่ง',
    }, foundTikTokBatch: {
        Intro: 'ใช้คุณสมบัติเดียวกันยื่นหลายบัญชี ระบบสร้างทีละบัญชี แนะนำ 50 ถึง 500 รายการต่อชุด เวลาตรวจสอบของ TikTok ไม่นับในรอบนี้',
        PreviewNote: 'นี่คือตัวอย่างขั้นตอนบนหน้าเว็บ จะไม่สร้างบัญชี TikTok รายการบัญชีจะเปิดเมื่อชื่อผู้ใช้อยู่ในไวท์ลิสต์ของระบบหลังบ้าน',
        PreviewMissing: 'ไม่พบชุดตัวอย่างนี้ กรุณาส่งใหม่',
        AccessChecking: 'กำลังตรวจสอบสิทธิ์',
        AccessClosedTitle: 'ยังไม่เปิดใช้การเปิดบัญชีเป็นชุด',
        AccessClosed: 'บัญชีนี้ไม่อยู่ในไวท์ลิสต์ โปรดให้ฝ่ายปฏิบัติการเพิ่มชื่อผู้ใช้ในเมนูตรวจสอบการเปิดบัญชี ไม่ต้องยื่นคำขออีก',
        AccessError: 'ยืนยันสิทธิ์ไม่ได้ชั่วคราว โปรดลองใหม่',
        AccessRetry: 'ตรวจสอบอีกครั้ง',
        Qualification: 'คุณสมบัติ',
        Accounts: 'รายชื่อบัญชี',
        AccountName: 'ชื่อบัญชี',
        AccountNameTip: 'ชื่อต้องไม่ซ้ำใน Business Center เดียวกัน',
        DramaName: 'ชื่อเรื่อง',
        DramaTip: 'หนึ่งบัญชีต่อหนึ่งเรื่อง เว้นว่างได้',
        Paste: 'วางรายชื่อ',
        PasteTitle: 'วางรายชื่อบัญชี',
        PasteTip: 'หนึ่งบรรทัดต่อหนึ่งรายการ หรือเขียนว่า "ชื่อบัญชี,ชื่อเรื่อง"',
        PastePlaceholder: 'DramaA-001,Drama A\nDramaA-002,Drama A',
        AddRow: 'เพิ่มแถว',
        Clear: 'ล้างรายการ',
        Generate: 'สร้างตามลำดับ',
        Prefix: 'คำนำหน้าชื่อ',
        StartNo: 'เลขเริ่มต้น',
        GenCount: 'จำนวน',
        Digits: 'หลัก',
        Append: 'เพิ่มเข้ารายการ',
        Valid: 'ใช้ได้',
        Duplicate: 'ชื่อซ้ำ',
        EmptyName: 'ยังไม่ใส่ชื่อ',
        OverLimit: 'เกิน 500 รายการ กรุณาแยกชุด',
        UnderLimit: 'ใส่ชื่อบัญชีอย่างน้อย 1 รายการ',
        LimitHint: 'แนะนำ 50 ถึง 500 รายการต่อชุด',
        Submit: 'ส่งชุดเปิดบัญชี',
        Single: 'เปิดบัญชีรายการเดียว',
        Result: 'ความคืบหน้า',
        BatchNo: 'เลขชุด',
        Pending: 'รอดำเนินการ',
        Processing: 'กำลังดำเนินการ',
        Success: 'สำเร็จ',
        Failed: 'ไม่สำเร็จ',
        Unknown: 'ผลยังไม่ชัด',
        All: 'ทั้งหมด',
        AdvertiserId: 'รหัสบัญชีโฆษณา',
        FailReason: 'สาเหตุ',
        RetryFailed: 'ส่งเฉพาะรายการที่ไม่สำเร็จ',
        RetryUnknown: 'ตรวจสอบรายการที่ผลยังไม่ชัด',
        Continue: 'เปิดอีกชุด',
        ViewRecord: 'ประวัติเปิดบัญชี',
        NoBatchNo: 'ไม่ได้รับเลขชุด',
        Polling: 'กำลังสร้างบัญชีทีละรายการ',
        StillRunning: 'ใช้เวลานาน รีเฟรชภายหลังเพื่อดูผล',
        Refresh: 'รีเฟรช',
        Total: 'ทั้งหมด',
        Unit: '',
        Filter: 'กรอง',
        Remove: 'ลบ',
        ConfirmClear: 'ล้างรายชื่อบัญชีปัจจุบันหรือไม่',
        NameRequired: 'ทุกแถวต้องมีชื่อบัญชีที่ไม่ซ้ำ',
        DramaOptional: 'เรื่อง',
    }, AccountList: {
        Account: 'ชื่อบัญชี',
        Budget: 'จำนวนเงินงบประมาณ',
        budgetCost: 'ปริมาณที่ใช้ไป',
        RequestID: 'รหัสบัญชี',
        RequestIDTip: 'กรุณากรอกรหัสบัญชีของคุณ',
        AccountTip: 'กรุณากรอกชื่อบัญชีของคุณ',
        AccountEntity: 'นิติบุคคลที่เปิดบัญชี',
        Media: 'แพลตฟอร์มสื่อ',
        status: 'สถานะบัญชี',
        AccountID: 'ชื่อบัญชี/รหัสบัญชี',
        Currency: 'สกุลเงิน',
        Balance: 'ยอดเงินในบัญชี',
        DailyBudget: 'งบประมาณรายวัน',
        AccountRecharge: 'การเติมเงินบัญชี',
        MinRechargePrice: 'จำนวนเงินเติมขั้นต่ำ',
        DeductionTransfer: 'การถ่ายโอนการลด',
        BindUnbind: 'ผูก/ถอนผูก',
        AccountRenaming: 'เปลี่ยนชื่อบัญชี',
        Fail: 'ล้มเหลว',
        Passed: 'ผ่านไปแล้ว',
        InReview: 'อยู่ระหว่างการพิจารณา',
        Operate: 'ดำเนินงาน',
        Reset: 'รีเซ็ต',
        Search: 'ค้นหา',
        BatchRecharge: 'การชาร์จแบตช์',
        BatchAdd: 'เพิ่มชุด',
        BatchOpen: 'การเปิดล็อต',
        ConfirmOpen: 'ยืนยันการเปิดใช้งาน',
        ConfirmClose: 'ยืนยันการปิด',
        BatchZeroing: 'การเคลียร์แบบแบตช์',
        BatchClose: 'ปิดล็อต',
        BatchBinding: 'การผูก/แยกชุด',
        ViewBC: 'ดู BC',
        NewName: 'ชื่อใหม่',
        NewNameTip: 'กรุณากรอกชื่อบัญชีใหม่',
        Cancel: 'ยกเลิก',
        Confirm: 'ส่ง',
        ConfirmModification: 'ยืนยันการแก้ไข',
        RechargeAmount: 'จำนวนเงินที่เติม',
        RechargeAmountTip: 'กรุณากรอกจำนวนเงินที่เติม',
        BudgetAmount: 'จำนวนงบประมาณ',
        CircuitTime: 'เวลารอบ',
        CircuitTimeTip: 'กรุณาป้อนเวลารอบ',
        BudgetAmountTip: 'กรุณาระบุจำนวนงบประมาณ',
        DailyBudgetTip: 'กรุณาป้อนงบประมาณรายวันของคุณ',
        ConfirmRecharge: 'ยืนยันการเติมเงิน',
        ConfirmClear: 'ยืนยันการเคลียร์',
        AddAccount: 'เพิ่มบัญชี',
        BCID: 'บีซีไอดี',
        EnterBCID: 'กรุณากรอก BC ID',
        SelectBCID: 'กรุณาเลือก BC ID',
        Email: 'อีเมล์',
        EnterEmail: 'กรุณากรอกที่อยู่อีเมล์ของคุณ',
        EnterEmail2: 'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง',
        SelectEmail: 'กรุณาเลือกที่อยู่อีเมล',
        Permission: 'คำอนุญาต',
        SelectPermission: 'กรุณาเลือกสิทธิ์',
        AccountSearch: 'กรุณากรอกชื่อบัญชีเพื่อค้นหาและเพิ่ม',
        Select: 'เลือก',
        Transfer: 'ใบสมัครโอนลดบัญชี',
        AccountBalance: 'ยอดเงินในบัญชี',
        EstimatedAeductibleAmount: 'จำนวนเงินที่หักลดหย่อนโดยประมาณ',
        TransferID: 'ชื่อบัญชี/ID การโอน',
        Type: 'ประเภท',
        TransferAccount: 'โอน',
        TransferAmount: 'การลด',
        TransferMoney: 'จำนวนเงินโอน',
        Num: 'เวลาที่เหลืออยู่',
        EnterTransferAmount: 'กรุณากรอกจำนวนเงินโอน',
        IsOut: 'ไม่ว่าทั้งหมดจะถูกโอนออกไปหรือไม่',
        Clear: 'เคลียร์',
        TransferredAccount: 'โอนเข้าบัญชี',
        SelectTransferAccount: 'กรุณาเลือกบัญชีโอน',
        BindBC: 'ผูก BC',
        UnbindBC: 'ยกเลิกผูก BC',
        BindEmail: 'ผูกอีเมล',
        UnbindEmail: 'ยกเลิกการเชื่อมโยงอีเมล',
        EnableMonitoring: 'เปิดใช้งานการตรวจสอบ',
        AddMonitoring: 'เพิ่มการตรวจสอบ',
        Edit: 'แก้ไข',
        Duration: 'ระยะเวลาเปิดบัญชี (วัน)',
        AccountOpeningTime: 'วันที่เปิดบัญชี',
        banTime: 'ระยะเวลาการปิดผนึกบัญชี',
    }, AccountRecord: {
        Media: 'แพลตฟอร์มสื่อ',
        Status: 'สถานะ',
        AccountEntity: 'นิติบุคคลเปิดบัญชี',
        ApplyNumber: 'รหัสใบสมัคร',
        PromotionLink: 'ลิงค์โปรโมชั่น',
        StartTime: 'เวลาเริ่มต้น',
        EndTime: 'เวลาสิ้นสุด',
        Reset: 'รีเซ็ต',
        Search: 'ค้นหา',
        Export: 'การส่งออก',
        AccountApplicationID: 'ชื่อบริษัท/รหัสแอปพลิเคชัน',
        CreatedTime: 'เวลาการใช้งาน',
        Operate: 'การดำเนินการ',
        AccountInfo: 'ข้อมูลบัญชี',
        AccountID: 'รหัสบัญชี',
        AccountName: 'ชื่อบัญชี',
        CompanyName: 'ชื่อบริษัท',
        Currency: 'สกุลเงิน',
        AccountBalance: 'ยอดเงินในบัญชี',
        View: 'มุมมอง',
        ViewAccount: 'ดูบัญชี',
        Edit: 'แก้ไข',
        Copy: 'สำเนา',
        RechargeTips: 'เคล็ดลับ: การตั้งค่าแผนการโฆษณาโดยใช้บัญชีโฆษณาที่ยังไม่ได้ชำระเงินอาจส่งผลให้บัญชีถูกปิดลง กรุณาชาร์จบัญชีโฆษณาของคุณก่อน ขอบคุณ',
    }, AccountRecharge: {
        Add: 'เพิ่มบัญชี',
        MediaAccount: 'บัญชีสื่อ',
        AccountPlacement: 'บัญชีการวางตำแหน่ง',
        SeriesName: 'ชื่อแคมเปญโฆษณา',
        SeriesNamePrompt: 'กรอกชื่อของแคมเปญ',
        SeriesStatus: 'สถานะแคมเปญ',
        BudgetStatus: 'การปรับปรุงงบประมาณชุดโปรโมชั่น',
        GroupName: 'ชื่อกลุ่มโฆษณา',
        PlGroupName: 'กรอกชื่อกลุ่มโฆษณา',
        GroupStatus: 'สถานะกลุ่มการโฆษณา',
        DeliveryMethod: 'วิธีการจัดส่งแบบสร้างสรรค์',
        AccountName: 'ชื่อบัญชี',
        MediaPlatform: 'แพลตฟอร์มสื่อ',
        MonitoringAmount: 'จำนวนการตรวจสอบ',
        RechargeAmount: 'จำนวนเงินที่ชาร์จ',
        CircuitTime: 'เวลารอบ',
        State: 'รัฐ',
        Modify: 'แก้ไข',
        Delete: 'ลบ',
        Operate: 'การดำเนินการ',
        IsDelete: 'คุณแน่ใจที่จะลบใช่ไหม',
        SelectMediaPlatform: 'กรุณาเลือกแพลตฟอร์มสื่อ',
        TransferAccount: 'โอนเข้าบัญชี',
        SelectTransferAccount: 'กรุณาเลือกบัญชีโอน',
        MonitoringBalance: 'การตรวจสอบยอดคงเหลือ',
        PutMonitoringBalance: 'กรุณาป้อนยอดคงเหลือในบัญชีที่ตรวจสอบ',
        PutRechargeAmount: 'กรุณากรอกจำนวนเงินที่เติม',
        MaximumTwoDecimal: 'ทศนิยมสูงสุดสองตำแหน่ง',
        IntervalTime: 'ช่วงเวลา',
        PutIntervalTime: 'กรุณาระบุจำนวนชั่วโมงในการลาดตระเวน',
        Hours: 'ชั่วโมง',
        Cancellation: 'ยกเลิก',
        Submit: 'ส่ง',
        PleaseEnterInteger: 'กรุณาใส่จำนวนเต็ม',
        SuccessfullyDeleted: 'ลบสำเร็จแล้ว',
        accountStatus: 'สถานะบัญชี',
        BudgetBalance: 'งบดุลดุล',
        AdvertisingAccountBalance: 'ยอดเงินในบัญชีโฆษณา',
        MonitoringTime: 'ระยะเวลาในการตรวจสอบ (ชม.)',
        StopDays: 'หยุดวัน (วัน)',
        TourTime: 'เวลาทัวร์',
        MonitoringStatus: 'สถานะการติดตาม',
        Remark: 'หมายเหตุ',

    }, AccountDetails: { //开户详情
        DocumentInformation: 'ข้อมูลเอกสาร',
        ApplicationID: 'รหัสแอปพลิเคชั่น',
        MediaPlatform: 'แพลตฟอร์มสื่อ',
        CreationTime: 'เวลาการสร้าง',
        AccountInformation: 'ข้อมูลบัญชี',
        AccountType: 'ประเภทบัญชี',
        Industry: 'อุตสาหกรรม',
        DeliveryCountry: 'ประเทศที่จัดส่ง',
        AccountTimeZone: 'เขตเวลาของบัญชี',
        AccountAuthorization: 'การอนุญาตบัญชี',
        PromotionLink: 'ลิงค์โปรโมชั่น',
        Authorization: 'การอนุญาต',
        Number: 'หมายเลขซีเรียล',
        EmailID: 'รหัสอีเมล/ศูนย์ธุรกิจที่ได้รับอนุญาต',
        Permission: 'การอนุญาต',
        EnterpriseInformation: 'ข้อมูลองค์กร',
        CompanyName: 'ชื่อบริษัทที่เปิดบัญชี (ภาษาจีน)',
        LicenseCode: 'รหัสเครดิตทางสังคมใบอนุญาตประกอบธุรกิจ',
        License: 'เอกสารแนบใบอนุญาตประกอบธุรกิจ',
    }, CheckWallet: {
        WalletRechargeOrder: 'คำสั่งเติมเงิน Wallet',
        AdvertisingTransactionOrders: 'การสั่งซื้อธุรกรรมการโฆษณา',
        AdvertisingConsumptionDetails: 'รายละเอียดการบริโภคโฆษณา',
        WalletRecharge: 'การเติมเงินกระเป๋าสตางค์',
        RechargeAmount: 'จำนวนเงินที่ชาร์จ',
        EnterRechargeAmount: 'กรุณากรอกจำนวนเงินที่เติม',
        PaymentMethod: 'วิธีการชำระเงิน',
        SelectPaymentMethod: 'กรุณาเลือกวิธีการชำระเงิน',
        Cancellation: 'ยกเลิก',
        ConfirmRecharge: 'ยืนยันการเติมเงิน',
        AdvertiserIdPlaceholder: "กรุณากรอกรหัสบัญชีโฆษณา",
        AdvertiserName: "กรุณากรอกชื่อโฆษณา",
        Reset: "รีเซ็ต",
        Search: "ค้นหา",
        StaticA: "สถิติ: ต้นทุนรวม:",
        StaticB: ",จำนวนการแสดงผลโฆษณาทั้งหมด:",
        StatTimeDay: "วันที่",
        AdvertiserId: "ชื่อบัญชีโฆษณา/ID บัญชีโฆษณา",
        Spend: "ยอดการบริโภครวม",
        Impressions: "จำนวนการแสดงผลโฆษณา",
        Balance: "ยอดคงเหลือในบัญชี",
        advertiserStatus: "สถานะบัญชี",
    }, Advertisement: { //广告管理
        advertisement: 'โฆษณา',
        adgroup: 'กลุ่มโฆษณา',
        campaign: 'แคมเปญโฆษณา',
        add: 'สร้างโฆษณาใหม่',

    }, CheckBalance: { // 钱包明细
        OrderNumber: 'หมายเลขคำสั่งซื้อ',
        ChangeType: 'ประเภทการเปลี่ยนแปลง',
        OperationType: 'ประเภทการดำเนินการ',
        Reset: 'รีเซ็ต',
        Search: 'ค้นหา',
        PreChangeAmount: 'จำนวนเงินก่อนการเปลี่ยนแปลง',
        ChangeAmount: 'จำนวนเงินที่เปลี่ยนแปลง',
        createdAt: 'เวลาที่สร้าง',
        AmountAfterChange: 'จำนวนเงินหลังการเปลี่ยนแปลง',
        Remarks: 'หมายเหตุ',
    }, CheckCredit: { // 钱包明细
        OrderNumber: 'หมายเลขคำสั่งซื้อ',
        ChangeType: 'ประเภทการเปลี่ยนแปลง',
        OperationType: 'ประเภทการดำเนินการ',
        Reset: 'รีเซ็ต',
        Search: 'ค้นหา',
        PreChangeAmount: 'จำนวนเงินก่อนการเปลี่ยนแปลง',
        createdAt: 'เวลาที่สร้าง',
        ChangeAmount: 'จำนวนเงินที่เปลี่ยนแปลง',
        AmountAfterChange: 'จำนวนเงินหลังการเปลี่ยนแปลง',
        Remarks: 'หมายเหตุ',
        MainContent: 'เนื้อหาหลัก'

    }, CheckAD: { // 广告交易订单
        AccountType: 'ประเภทบัญชี',
        OrderNumber: 'หมายเลขคำสั่งซื้อ',
        AdvertisingName: 'ชื่อโฆษณา',
        OperationType: 'ประเภทการดำเนินการ',
        Status: 'สถานะ',
        TransferStatus: 'สถานะการโอน',
        Reset: 'รีเซ็ต',
        Search: 'ค้นหา',
        PlatformType: 'ประเภทแพลตฟอร์ม',
        Account: 'จำนวนเงิน',
        TransferPlatform: 'แพลตฟอร์มบัญชีโฆษณาโอน',
        TransferPlatformId: 'โอนชื่อบัญชีโฆษณา/โอนรหัสบัญชีโฆษณา',
        AccountId: 'ชื่อบัญชีโฆษณา/ID บัญชีโฆษณา',
        Remarks: 'หมายเหตุ',
        CreatedAt: 'เวลาทำธุรกรรม',

    }, CheckPay: { // 钱包充值订单
        Sn: 'หมายเลขคำสั่งซื้อ',
        Status: 'สถานะการสั่งซื้อ',
        Reset: 'รีเซ็ต',
        Search: 'ค้นหา',
        CurrencyName: 'สกุลเงิน',
        PayTypeName: 'วิธีการชำระเงิน',
        Amount: 'จำนวนเงินที่เติม',
        ExpiresAt: 'เวลาหมดอายุของคำสั่งซื้อ',
        PayTime: 'ระยะเวลาการชำระเงิน',
        Operate: 'การดำเนินการ',
        ImmediatePayment: 'ชำระเงินทันที',
    }, Settings: {
        Account: "ข้อมูลบัญชี",
        Company: "ข้อมูลบริษัท",
        EmailBind: "ผูกอีเมล",
        PasswordUpdate: "การแก้ไขรหัสผ่าน",
        Avatar: "อวตาร",
        Nickname: "ชื่อเล่นผู้ใช้",
        NicknamePlaceholder: "กรุณากรอกชื่อเล่นของผู้ใช้ของคุณ",
        NicknameRule: "ความยาวชื่อเล่นของผู้ใช้รองรับเฉพาะ (3~20) เท่านั้น",
        SubmitForm: 'ส่ง',
        Upload: "รูปภาพไม่สามารถเกิน 10M",
        UpdateSuccess: "อัปเดตสำเร็จแล้ว",
        EnterpriseName: "ชื่อองค์กร",
        EnterpriseEmail: "อีเมลขององค์กร",
        EnterprisePhone: "เบอร์ติดต่อ",
        EnterpriseAddress: "ที่อยู่องค์กร",
        EnterpriseNamePlaceholder: "กรุณากรอกชื่อบริษัท",
        EnterpriseEmailPlaceholder: "กรุณาป้อนที่อยู่อีเมลของบริษัทของคุณ",
        EnterprisePhonePlaceholder: "กรุณากรอกเบอร์โทรศัพท์ติดต่อ",
        EnterpriseAddressPlaceholder: "กรุณาป้อนที่อยู่ขององค์กร",
        Email: "อีเมล์",
        OldEmailCode: "รหัสยืนยันอีเมล์",
        OldEmailCodePlaceholder: "กรุณาป้อนรหัสยืนยันสำหรับที่อยู่อีเมลที่ผูกไว้",
        SendSms: "ส่งรหัสยืนยัน",
        BindEmail: "ผูกอีเมล",
        BindEmailPlaceholder: "กรุณาป้อนที่อยู่อีเมลที่ผูกไว้",
        BindEmailCode: "รหัสยืนยันอีเมล์",
        BindEmailCodePlaceholder: "กรุณาป้อนรหัสยืนยันอีเมล์",
        SendCodeSuccess: "ส่งรหัสยืนยันเรียบร้อยแล้ว",
        EmailBindSuccess: "การเชื่อมโยงอีเมลสำเร็จแล้ว",
        EmailBindCodePlaceholder: "กรุณาป้อนรหัสยืนยันอีเมล์",
        EmailSuccess: "กรุณาป้อนที่อยู่อีเมลที่ถูกต้อง",
        OldPassword: "รหัสผ่านเก่า",
        OldPasswordPlaceholder: "กรุณากรอกรหัสผ่านเดิม",
        Password: "รหัสผ่านใหม่",
        PasswordPlaceholder: "กรุณากรอกรหัสผ่านใหม่ของคุณ",
        RePassword: "ยืนยันรหัสผ่าน",
        RePasswordPlaceholder: "กรุณากรอกรหัสผ่านที่ได้รับการยืนยันแล้ว",
        PasswordUpdateSuccess: "การแก้ไขรหัสผ่านสำเร็จแล้ว",
        UserAccount: "บัญชีผู้ใช้",
        ChangePhoneNumber: "เปลี่ยนเบอร์โทรศัพท์มือถือ",
    }, Help: {
        ReleaseTime: "เวลาปล่อยตัว",
        Title: "ชื่อ",
    }, Other: {
        TikTokPlatform: "แพลตฟอร์ม TikTok-การสมัครบัญชี",
        NewQualification: "คุณสมบัติใหม่",
        VerifiedQualifications: "คุณสมบัติที่ผ่านการตรวจสอบ",
        SelectVerifiedQualification: "เลือกคุณสมบัติที่ผ่านการตรวจสอบเพื่อนำมาใช้ซ้ำ",
        AutomaticallyReview: "บัญชีโฆษณาที่สร้างด้วยข้อมูลประจำตัวที่ผ่านการตรวจสอบจะผ่านการตรวจสอบโดยอัตโนมัติ",
        SelectVerifiedQualifications: "กรุณาเลือกคุณสมบัติที่ผ่านการตรวจสอบ",
        AdvertisingAccounts: "บัญชีการโฆษณา",
        AdvertisingArea: "พื้นที่โฆษณา",
        PleaseSelectAdvertising: "กรุณาเลือกพื้นที่โฆษณา",
        NumberApp: "จำนวนแอปพลิเคชัน",
        PleaseNumberApp: "กรุณากรอกจำนวนใบสมัคร",
        LegalPerson: "ชื่อนิติบุคคล",
        PleaseLegalPerson: "กรุณากรอกชื่อนิติบุคคล",
        IDNumber: "บัตรประจำตัวนิติบุคคล",
        PleaseIDNumber: "กรุณากรอกบัตรประจำตัวนิติบุคคล",
        BankAccountNumber: "หมายเลขบัญชีธนาคารของนิติบุคคล",
        PleaseBankAccountNumber: "กรุณากรอกหมายเลขบัญชีธนาคารของนิติบุคคล",
        BankMobileNumber: "หมายเลขโทรศัพท์มือถือของนิติบุคคล",
        PleaseBankMobileNumber: "กรุณากรอกหมายเลขโทรศัพท์มือถือของนิติบุคคล",
        AccountSelection: "การเลือกบัญชี",
        FormEntry: "การป้อนแบบฟอร์ม",
        BulkAdvertisingAccounts: "คุณสามารถคัดลอก ID บัญชีโฆษณาจาก Excel ได้โดยตรง โดยคั่นด้วยช่องว่าง ดังที่แสดงด้านล่าง",
        BatchSearch: "การค้นหาแบบแบตช์",
        ConfirmSub: "ยืนยันการส่ง",
        AddRunningAccount: "เพิ่มบัญชีการวิ่ง",
        MonitorStatus: "สถานะการตรวจสอบ",
        Balance: "ความสมดุล",
        ConfirmStop: "ยืนยันการหยุด",
        RunAccountList: "เรียกใช้รายการบัญชี",
        SearchRunAccount: "ค้นหาบัญชีที่กำลังทำงาน",
        BatchClose: "การดำเนินการปิดแบตช์",
        RemainingTimes: "จำนวนการโอนที่เหลือในวันนี้",
        UKTimeZone: "หมายเหตุ: โปรดทราบว่าบัญชีเดียวสามารถโอนได้ 10 ครั้งต่อวัน และเวลาดำเนินการจะขึ้นอยู่กับเขตเวลาของสหราชอาณาจักร~",
        PleaseEnterBalance: "กรุณาใส่ยอดคงเหลือ",
        PleaseBudgetBalance: 'กรุณาป้อนยอดคงเหลือของงบประมาณ',
        EditorialMonitor: 'การติดตามงานบรรณาธิการ',
        AdvertiseAccountID: 'รหัสบัญชีโฆษณา',
        ConfirmAdd: 'ยืนยันการเพิ่ม',
        SearchAddAccount: 'ค้นหาและเพิ่มบัญชี',
        AddEnableAccounts: 'เพิ่มบัญชีที่เปิดใช้งานแบบเป็นชุด',
        OpenAccountList: 'เปิดรายการบัญชี',
        BatchOperations: 'การดำเนินการแบบแบตช์',
        Phone: 'หมายเลขโทรศัพท์มือถือ',
        ReleaseArea: 'พื้นที่ปล่อยตัว',
        WeChatBind: 'วีแชทไบนด์',
        Bind: 'ผูก',
        UnBind: 'ยกเลิกการผูก',
        SubCustomerAlias: 'นามแฝงไคลเอนต์ย่อย',
        SubCustomers: 'ลูกค้ารายย่อย',
        PleaseSubCustomerAlias: 'กรุณาระบุชื่อแทนลูกค้าย่อย',
        AccountBalance: 'ยอดคงเหลือในบัญชี',
        KwaiPlatform: "Kwai Platform - ใบสมัครเปิดบัญชี",
        BusinessScope: "ขอบเขตธุรกิจ",
        BusinessLicense: "ขอบเขตธุรกิจ กรุณาระบุใบอนุญาตประกอบธุรกิจให้ตรงกับใบอนุญาตประกอบธุรกิจของคุณ",
        AdType: "ประเภทบัญชีโฆษณา",
        EffectAdAccount: "บัญชีโฆษณาประสิทธิภาพสูง",
        Industry: "อุตสาหกรรมเนื้อหา",
        SeleteIndustry: "กรุณาเลือกอุตสาหกรรมเนื้อหา",
        ProductBrandName: "ชื่อผลิตภัณฑ์หรือแบรนด์",
        PleaseProductBrandName: "กรุณาระบุชื่อผลิตภัณฑ์หรือแบรนด์",
        PleaseRregisAddress: "กรุณาระบุที่อยู่จดทะเบียนบริษัท",
        RregisAddress: "ที่อยู่จดทะเบียนบริษัท",
        CheckEmail: "ตรวจสอบ อีเมล",
        BindEmail: "อีเมลที่ผูกแล้ว",
        UnbindEmail: "อีเมลที่ยังไม่ได้ผูก",
        BindUnbindEmail: "อีเมลที่ผูกแล้ว/ยังไม่ได้ผูก",
        SerialNumber: "หมายเลข",
        BindStatus: "สถานะการผูก",
        GooglePlatform: "Google แพลตฟอร์ม แอปพลิเคชันเปิดบัญชี"
    }, Omissions: {
        OnlineRecharge: 'การเติมเงินออนไลน์',
        ActualAmount: 'จำนวนเงินที่ชำระจริง',
        SelectRechargeMethod: 'เลือกวิธีการชาร์จเงิน',
        OnlinePay: 'การชำระเงินออนไลน์',
        OfflineTransfer: 'การโอนแบบออฟไลน์',
        Recommend: 'แนะนำ',
        OnlinePayMethods: 'เลือกวิธีการชำระเงินออนไลน์สำหรับการเติมเงิน RMB รองรับการใช้งาน',
        USDPayoptions: 'รองรับการโอนออฟไลน์สำหรับการเติมเงิน USD',
        RemainingBalance: 'ยอดคงเหลือ',
        Increase: 'เพิ่มขึ้น',
        Decrease: 'ลด',
        ExchangeRate: 'อัตราแลกเปลี่ยน',
        HandlingFees: 'ค่าธรรมเนียมการจัดการ',
        TransactionDetails: 'รายละเอียดธุรกรรม',
        TransactionID: 'รหัสธุรกรรม',
        TransactionVoucher: 'หลักฐานการทำธุรกรรม',
        Remark: 'หมายเหตุ',
        DeductedBalance: 'หักยอดคงเหลือ',
        MonitoringOn: 'การติดตามตรวจสอบ',
        MonitoringOff: 'ปิดการตรวจสอบ',
        MasterAccount: 'บัญชีหลัก',
        SubAccount: 'บัญชีรอง',
        Username: 'ชื่อผู้ใช้',
        AdvertiserNum: 'จำนวนบัญชีโฆษณา',
        CreditBalance: 'ยอดเครดิต',
        LastLoginTime: 'เวลาเข้าสู่ระบบครั้งสุดท้าย',
        BalanceAllocation: 'การจัดสรรยอดคงเหลือ',
        AccountAllocation: 'การจัดสรรบัญชี',
        ResetPassword: 'รีเซ็ตรหัสผ่าน',
        UserDetail: 'รายละเอียดบัญชี',
        NewAccount: 'บัญชีใหม่',
        LogRecording: 'บันทึกรายการบันทึก',
        AddSubUser: 'เพิ่มบัญชีรอง',
        PleaseName: 'กรุณาใส่ชื่อ (ไม่เกิน 5 ช่อง)',
        LoginPassword: 'กรุณาใส่รหัสผ่านเข้าสู่ระบบ 6-20 หลัก (รวมทั้งตัวอักษรพิมพ์ใหญ่และพิมพ์เล็ก)',
        ConfigPleasePassword: 'กรุณาใส่รหัสผ่านอีกครั้ง',
        username: 'ชื่อผู้ใช้',
        pleasePassword: 'ยืนยันรหัสผ่าน',
        AdjustmentType: 'ประเภทรายการปรับปรุงบัญชี',
        Confirm: 'ยืนยัน',
        AssignedAdvertAccounts: 'บัญชีโฆษณาที่ได้รับมอบหมาย',
        AddSubUserDetail: 'รายละเอียดบัญชีย่อย',
        AllocatedAmount: 'จำนวนเงินที่ได้รับการจัดสรร',
        AdvertiserName: 'ชื่อบัญชี',
        AdvertiserID: 'รหัสบัญชี',
        ConsumedBalance: 'ยอดคงเหลือที่ใช้ไป',
        SystemInfo: 'ข้อมูลระบบ',
        CurrentWalletBalance: 'ยอดเงินในกระเป๋าสตางค์ปัจจุบัน',
        CurrentCreditBalance: 'ยอดเงินเครดิตปัจจุบัน',
        AdjustmentAmount: 'จำนวนเงินที่ปรับแก้',
        PleaseAdjustmentAmount: 'กรุณาใส่จำนวนเงินที่ปรับแก้',
        PleaseSelectType: 'กรุณาเลือกประเภท',
        MasterAccountBalance: 'ยอดเงินในบัญชีหลัก',
        MasterAccountCreditBalance: 'ยอดเงินเครดิตบัญชีหลัก',
        AccountRecycle: 'รีไซเคิลบัญชี',
        AccountRecycleList: 'รายการรีไซเคิลบัญชี'

    },
    SubClient: {
        OnlineRecharge: 'เติมเงินออนไลน์',
        ProxyLinks: 'ลิงก์พร็อกซี',
        SubManagement: 'การจัดการลูกค้าย่อย',
        RiskControlStatus: 'สถานะการควบคุมความเสี่ยง',
        Normal: 'ปกติ',
        Disable: 'ปิดการใช้งาน',
        Username: 'ชื่อผู้ใช้',
        Mail: 'อีเมล',
        WalletBalance: 'ยอดเงินในกระเป๋าเงิน',
        AccountBalance: 'ยอดคงเหลือเครดิต',
        AdvertiserNumber: 'จำนวนบัญชีโฆษณา',
        Phone: 'หมายเลขโทรศัพท์',
        BalanceRecharge: 'การลดยอดคงเหลือ',
        BalanceReduction: 'การลดยอดคงเหลือ',
        BasicInformation: 'ข้อมูลพื้นฐาน',
        UserUpdate: 'การเปลี่ยนชื่อผู้ใช้',
        LinkAccounts: 'บัญชีที่เชื่อมโยง',
        TransactionRecords: 'บันทึกธุรกรรม',
        OpenRecords: 'บันทึกการเปิดบัญชี',
        UserId: 'รหัสผู้ใช้',
        ReductionChannels: 'ช่องทางการลดราคา',
        MyBalance: 'ยอดคงเหลือของฉัน',
        SubClientBalance: 'ยอดคงเหลือของลูกค้าย่อย',
        AmountReduction: 'จำนวนเงินที่ลด',
        PleaseAmountReduction: 'กรุณาระบุจำนวนเงินที่ลด',
        BalanceAfterDeduction: 'ยอดคงเหลือหลังการลดราคา',
        Remark: 'หมายเหตุ',
        PleaseRemark: 'กรุณาระบุหมายเหตุ',
        Recharge: 'เติมเงิน',
        RechargeChannels: 'ช่องทางการเติมเงิน',
        RechargeAmount: 'จำนวนเงินที่เติม',
        PleaseRechargeAmount: 'กรุณาระบุจำนวนเงินที่เติม',
        BalanceAfterRecharge: 'ยอดคงเหลือหลังการเติมเงิน',
        EditName: 'แก้ไขชื่อ',
        ChangeName: 'เปลี่ยนชื่อ',
        SubClientname: 'ชื่อลูกค้าย่อย',
        AdvertiserNum: 'จำนวนโฆษณา',
        LoginRest: 'ขีดจำกัดการเข้าสู่ระบบ',
        OpenRest: 'ขีดจำกัดการเปิดบัญชี',
        AccountClosureRate: 'อัตราการปิดบัญชี',
        LastLoginIP: 'IP สำหรับการเข้าสู่ระบบครั้งล่าสุด',
        LastLoginTime: 'เวลาการเข้าสู่ระบบครั้งล่าสุด',
        Reduction: 'การลด',
        Operator: 'ผู้ดำเนินการ',
        TransactionAmount: 'จำนวนเงินธุรกรรม',
        CreditBalanceRecord: 'รายละเอียดยอดคงเหลือเครดิต',
    },
    Notice: {
        BatchRead: 'อ่านเป็นกลุ่ม',
        MessageStatus: 'สถานะข้อความ',
        Title: 'หัวข้อ',
        Summary: 'สรุป',
        ReleaseTime: 'เวลาที่เผยแพร่',
        MessageType: 'ประเภทข้อความ',
        Operate: 'การดำเนินการ',
        QueryDetails: 'รายละเอียดการค้นหา',
        Details: 'รายละเอียด',
        PleaseEnterMessageTitle: 'กรุณากรอกหัวข้อข้อความ',
        All: 'ทั้งหมด',
        Read: 'อ่านแล้ว',
        Unread: 'ยังไม่อ่าน',
        SystemNotice: 'การแจ้งเตือนระบบ',
        OrdinaryNotice: 'การแจ้งเตือนทั่วไป',
    },
    Zero:{
        ConfirmBatchZero: 'ยืนยันการล้างข้อมูลเป็นศูนย์แบบกลุ่ม',
        Reminder: 'การแจ้งเตือนการล้างข้อมูลเป็นศูนย์',
        Prompt1: '1. จำนวนเงินโอนสุดท้ายขึ้นอยู่กับจำนวนเงินจริงในแพลตฟอร์ม',
        Prompt2: '2. จำนวนเงินที่ล้างเป็นศูนย์สุดท้ายขึ้นอยู่กับจำนวนเงินจริงในแพลตฟอร์ม คุณสามารถดูจำนวนเงินที่ล้างเป็นศูนย์จริงได้ในบันทึกการเปลี่ยนแปลงจำนวนเงินของการจัดการบิล ระยะเวลาดำเนินการคือ 1-3 วันทำการ',
        Prompt3: '3. ขณะนี้ การล้างข้อมูลเป็นศูนย์รองรับเฉพาะบัญชีโฆษณาที่ถูกระงับเท่านั้น',
    },
    Partner:{
        marketingToolintro: 'มุ่งเน้นการพัฒนาเครื่องมือเพิ่มประสิทธิภาพสำหรับระบบนิเวศของ TikTok เพื่อทำความเข้าใจระบบนิเวศอีคอมเมิร์ซของอินฟลูเอนเซอร์ TikTok ให้ดียิ่งขึ้น',

        crossBorderBrowserintro: 'เบราว์เซอร์ Zhanfu มอบสภาพแวดล้อมการทำงานที่ปลอดภัยและเป็นอิสระสำหรับแต่ละบัญชี',

        storeOperationToolsintro: 'มุ่งเน้นการพัฒนาเครื่องมือเพิ่มประสิทธิภาพสำหรับระบบนิเวศของ TikTok เพื่อทำความเข้าใจระบบนิเวศอีคอมเมิร์ซของอินฟลูเอนเซอร์ TikTok ให้ดียิ่งขึ้น',

        USCloudPhoneintro: 'Ushop ระบบ ERP สำหรับการจัดการร้านค้าอัจฉริยะ',

        TermsService: 'ชุดเครื่องมือที่แนะนำนี้จัดทำโดยพันธมิตรของ Adseasy และ Dongkun Technology และไม่ใช่บริการของแพลตฟอร์มนี้ โปรดยืนยันเนื้อหาบริการและข้อตกลงของแพลตฟอร์มที่เกี่ยวข้องก่อนใช้งาน',

        serviceRecommendation: 'คำแนะนำบริการ',

        marketingToolDetail: "การเชิญแบบกลุ่ม/การส่งข้อความส่วนตัวไปยังอินฟลูเอนเซอร์อย่างเสถียร เข้าถึงอินฟลูเอนเซอร์หลายหมื่นคนต่อวัน' เข้าถึงฐานข้อมูลอินฟลูเอนเซอร์นับล้านที่มีความแม่นยำสูงได้ฟรี พร้อมสคริปต์ที่สร้างโดย AI และการตอบกลับอัตโนมัติด้วย AI ในหลายภาษา รองรับวิธีการทั้งในและนอกเว็บไซต์หลายวิธี เช่น การส่งอีเมลจำนวนมาก ให้ข้อมูลเชิงลึกเกี่ยวกับอินฟลูเอนเซอร์ที่ขายสินค้าจากคู่แข่งและร้านค้าในกลุ่มเดียวกัน เข้าถึงได้ด้วยการคลิกเพียงครั้งเดียวผ่าน DaMi และรวมถึงระบบจัดการอินฟลูเอนเซอร์พร้อมกระบวนการจัดการคำเชิญที่เป็นมาตรฐาน รายละเอียด",

         crossBorderBrowser: 'ลงทะเบียนตอนนี้เพื่อรับประสบการณ์คูปองแบบไม่มีเงื่อนไข การดำเนินงานร้านค้าที่ปลอดภัยและมีประสิทธิภาพ Zhanfu Browser มอบสภาพแวดล้อมการทำงานที่ปลอดภัยและเป็นอิสระสำหรับแต่ละบัญชี',

        storeOperationTools: 'มุ่งมั่นที่จะสร้างเครื่องมือระบบการจัดการและการดำเนินงานอีคอมเมิร์ซอัตโนมัติด้วย AI รองรับร้านค้าในประเทศและต่างประเทศบนแพลตฟอร์มอีคอมเมิร์ซหลายแห่ง เช่น TikTok, Lazada, Shopee และ Shein',

         USCloudPhone: "เวลาตอบสนองระดับมิลลิวินาที ราบรื่นกว่าที่เคย' รองรับแพลตฟอร์มต่างๆ เช่น Pinduoduo, Douyin Store, Taobao, Shopee, PayPal, TikTok และอื่นๆ อีกมากมาย; การจัดการบัญชีบนคลาวด์ที่เป็นระเบียบ; การส่งข้อมูลที่รวดเรวยิ่งขึ้น"
    },
    MonthSettlement: {
        list: 'รายการเรียกเก็บเงินรายเดือน',
        enterpriseName: 'ชื่อบริษัท',
        monthBill: 'เดือนที่เรียกเก็บเงิน',
        money: 'จำนวนเงินที่เรียกเก็บปัจจุบัน',
        file: 'ดาวน์โหลด',
        createdAt: 'เวลาที่สร้าง',
        remark: 'หมายเหตุเพิ่มเติม',
    }

}